import React from 'react';

// CSS
import './menu-hero.css';

const MenuHero = () => {
  return (
    <section className="menu-hero">
      <div className="menu-hero-container">
        <h1 className="menu-hero-headline">Explore Our Mouth-Watering Menu</h1>
        <h2 className="menu-hero-subheadline">
          Homemade meals, prepared with love & delivered fresh to your doorstep
        </h2>
        <div className="menu-hero-cta">
          <a href="/menu#menu-categories" className="btn btn-primary">
            View Categories
          </a>
          <a href="/menu#full-menu" className="btn btn-secondary">
            View Full Menu
          </a>
        </div>
      </div>
    </section>
  );
};

export default MenuHero;
